import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CloudApiService } from '@/cloud/services/cloud-api.service';

/**
 * Guards namespace-detail admin routes: superadmin, or a role granting
 * members.manage / namespace.manage on the :namespaceId in the route.
 */
export const namespaceAdminGuard: CanActivateFn = async (route) => {
    const api = inject(CloudApiService);
    const router = inject(Router);

    // Wait for the cold-load session restore before judging auth state.
    await api.sessionReady;

    if (!api.isAuthenticated()) {
        return router.createUrlTree(['/auth/login'], { queryParams: { returnUrl: router.url } });
    }

    // Capability resolution needs role definitions; harmless no-op when already cached.
    try {
        await api.getRoles();
    } catch {
        // Roles endpoint unavailable — hasCapability falls back to the legacy tier mapping.
    }

    const namespaceId = route.paramMap.get('namespaceId');
    const allowed = api.hasCapability(namespaceId, 'members.manage') || api.hasCapability(namespaceId, 'namespace.manage');

    return allowed ? true : router.createUrlTree(['/dashboard']);
};
